import createNamedExpression from '../helpers/createNamedExpression';
export function get() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return createNamedExpression('get', args);
}
export var propertyOf = get;
